{
  "app": {
    "default-meta-title": "Eversports - Widget",
    "error-fetching-data": "An unexpected error when fetching data",
    "show-all": "Show all"
  },
  "profile": {
    "login": "Login",
    "register": "Register",
    "log-out": "Log out",
    "name": "name",
    "my-bookings": "My Bookings",
    "my-details": "My Details",
    "my-products": "Passes and Memberships",
    "my-videos": "My Videos",
    "book-for-a-family-member": "Book for a family member"
  },
  "footer": {
    "we-use-eversports-label": "we use",
    "privacy-policy": "Privacy Policy",
    "terms-and-conditions": "Terms & Conditions"
  },
  "activity-details": {
    "succesfully-booked": "Booked",
    "manage-in-my-bookings": "Manage in 'My Bookings'",
    "we-use-eversports-label": "we use",
    "activity-not-found": "Activity not found. Please contact the venue.",
    "venue-information-header": "Venue information",
    "venue-reviews-header": "Reviews",
    "specific-availability-remaining": "{freeSpots, plural, =1 {free spot}\n other {free spots}}",
    "numeric-availability-remaining": "{freeSpots} {freeSpots, plural, =1 {free spot}\n other {free spots}}",
    "generic-availability-remaining": "more than {displayLimit}",
    "sold-out": "Sold out",
    "number-of-spots-available": "{spotsLeft}/{total} spots available",
    "unlimited-availability": "Unlimited",
    "free-spots-available": "free spots available",
    "book-now": "Book now",
    "book-now-from": "Book now from {cheapestPrice}",
    "not-bookable": "Not bookable",
    "event-is-cancelled-label": "Cancelled",
    "already-registered": "Already registered",
    "event-already-occured-label": "Already concluded",
    "event-fully-booked-label": "Fully booked",
    "event-bookable-from-label": "Bookable from {registrationStartDate, date, medium}",
    "waitlist-add-yourself": "Add to waitlist",
    "waitlist-remove-yourself": "Remove me from waitlist",
    "waitlist-on-waitlist": "On waitlist",
    "waitlist-on-waitlist-message": "You are currently on the waiting list. If a spot is free you will be notified with a push notification in the Eversports app.",
    "waitlist-add-yourself-message": "If a spot gets free you will be notified with a push notification in the Eversports app. (You are not automatically registered.)",
    "waitlist-download-apps-title": "Eversports app is required for waitlist notifications",
    "waitlist-download-apps-description": "If a spot gets free you will be notified with a push notification in the Eversports app. (You are not automatically registered.)",
    "waitlist-label": "Waitlist",
    "urgency-limited-spots": "Only {freeSpots, selectordinal, =1 {one}\n =2 {two}\n =3 {three}\n =4 {four}\n other {a few}} {freeSpots, plural, =1 {spot}\n other {spots}} left!",
    "calendar-description": "Book your class here: {activityUrl}",
    "calendar-summary": "{sportName} {eventType, select, \n Camp {camp} \n Class {class} \n Course {course} \n Education {education} \n Event {event} \n OpenTraining {open training} \n Retreat {retreat} \n Training {training} \n Workshop {workshop} \n other {activity}} - {activityName}",
    "difficulty-header": "Level",
    "language-header": "Language",
    "location-header": "Location",
    "room-header": "Room",
    "activity-type-header": "Activity",
    "online-location": "Online",
    "multiple-locations": "Multiple locations - see schedule",
    "meta-description": "Check out {activityName} at {venueName}. Reserve your spot for this {sportName} activity today!",
    "teacher-label": "teacher",
    "trainer-label": "trainer",
    "teacher-heading": "{trainerCount, plural, =1 {Teacher}\n other {Teachers}}",
    "trainer-heading": "{trainerCount, plural, =1 {Trainer}\n other {Trainers}}",
    "trainer-education": "Education",
    "trainer-description": "About",
    "share-label": "Share",
    "membership-price": "{recurringValue} / {intervalValue, select, \n 1 {} \n other {{intervalValue}}} {intervalType, select, \n INTERVAL_UNIT_DAYS {{intervalValue, plural, =1 {day}\n other {days}}} \n INTERVAL_UNIT_HOURS {{intervalValue, plural, =1 {hour}\n other {hours}}} \n INTERVAL_UNIT_MONTHS {{intervalValue, plural, =1 {month}\n other {months}}} \n INTERVAL_UNIT_WEEKS {{intervalValue, plural, =1 {week}\n other {weeks}}} \n INTERVAL_UNIT_YEARS {{intervalValue, plural, =1 {year}\n other {years}}} \n other {period}}",
    "schedule-heading": "Schedule",
    "schedule-subheading": "Check out which dates are available for this event",
    "ticket-schedule-heading": "Activity list for this ticket",
    "ticket-upcoming-sessions-label": "Upcoming sessions",
    "ticket-past-sessions-label": "Past sessions",
    "schedule-table-date-header": "Date",
    "schedule-table-time-header": "Time",
    "schedule-table-location-header": "Location",
    "schedule-table-teacher-header": "Teacher",
    "reviews-show-more": "Show more",
    "date-label": "Date",
    "time-label": "Time",
    "multi-session-start-date": "Starts on {startDate}",
    "multi-session-started-on-date": "Started on {startDate}",
    "multi-sessions-label": "Multiple sessions - see schedule",
    "location-label": "Location",
    "online-label": "Online",
    "cancellation-policy-header": "Cancellation policy",
    "availability-label": "Availability",
    "products-heading": "Products",
    "pricing-options-heading": "Pricing options",
    "ticket-options-heading": "Ticket options",
    "product-table-price-header": "Price",
    "product-table-purchase-option-header": "Purchase option",
    "product-table-pricing-option-header": "Pricing option",
    "product-table-ticket-option-header": "Ticket option",
    "get-it-on-label": "Get it on",
    "app-store-label": "App store",
    "google-play-label": "Google Play",
    "trial-price-label": "Intro Offer",
    "corporate-price-label": "Corporate Deal",
    "membership-price-label": "Membership",
    "membership-promotion-label": "% Discount",
    "early-bird-price-label": "Early Bird",
    "last-minute-price-label": "Last Minute",
    "products-show-more": "Show more",
    "show-more": "Show more",
    "calendar-file-event-description": "Book your activity or view activity information: {url}",
    "calendar-label": "Calendar",
    "at-venue-label": "at",
    "online-stream-header": "Online stream",
    "online-stream-subtext": "There is an online stream available for this activity. To participate, take the following steps:",
    "online-stream-instructions-step-1": "This studio uses Zoom as their online streaming provider. Download the according app to your laptop, tablet or smartphone",
    "online-stream-instructions-step-2": "Access to the online livestream is available 15 minutes before the start of the activity. Simply go to \"My bookings\" and click on \"Join online stream now\" to be redirected to the corresponding page",
    "online-stream-instructions-step-3": "With some streaming providers (e.g. Zoom) it is possible for participants to see each other. However, it is theoretically possible to deactivate the camera function. The name you enter when entering the online meeting room is displayed to other participants. However, you can always change your name (e.g. only the initials). Please note: Individual rules for online participation may apply for each class or venue.",
    "event-type": "{eventType, select, \n Camp {camp} \n Class {class} \n Course {course} \n Education {education} \n Event {event} \n OpenTraining {open training} \n Retreat {retreat} \n Training {training} \n Workshop {workshop} \n other {activity}}",
    "single-session-sharing-message": "Hey, I found this {sportName} {eventType, select, \n Camp {camp} \n Class {class} \n Course {course} \n Education {education} \n Event {event} \n OpenTraining {open training} \n Retreat {retreat} \n Training {training} \n Workshop {workshop} \n other {activity}} from {venueName}: {activityName} \n \n 📅 {formattedDate} \n ⏰ {startTime} - {endTime} ({formattedDuration}) \n 🏠 {venueName} \n {trainerName, select, \n unknown {👫 No trainer specified} \n other {👫 Instructed by {trainerName}}}  \n \n ➡️ Save your spot here: {activityUrl}",
    "multi-session-sharing-message": "Hey, I found this {sportName} {eventType, select, \n Camp {camp} \n Class {class} \n Course {course} \n Education {education} \n Event {event} \n OpenTraining {open training} \n Retreat {retreat} \n Training {training} \n Workshop {workshop} \n other {activity}} from {venueName}: {activityName} \n \n 📅 Start Date: {formattedDate} \n ⏰ Number of sessions: {sessionCount} \n 🏠 {venueName} \n \n ➡️ Save your spot here: {activityUrl}"
  },
  "activity-event-type": {
    "camp": "Camp",
    "class": "Class",
    "course": "Course",
    "education": "Education",
    "event": "Event",
    "open-training": "Training",
    "retreat": "Retreat",
    "training": "Training",
    "workshop": "Workshop"
  },
  "activities-widget": {
    "camps": "Camps",
    "classes": "Classes",
    "courses": "Courses",
    "education": "Education",
    "events": "Events",
    "open-trainings": "Open trainings",
    "other": "Other",
    "retreats": "Retreats",
    "trainings": "Trainings",
    "workshops": "Workshops",
    "show-all": "Show all",
    "no-results-header": "No results found",
    "no-results-message": "We could not find any activities, try adjusting the filters.",
    "multi-session-number-of-sessions": "{sessionCount} {sessionCount, plural, =1 {session}\n other {sessions}}",
    "load-more": "Load more",
    "online-label": "Online",
    "start-date-label": "Start date",
    "end-date-label": "End date",
    "date-range-starting-from": "From: {startDate}",
    "date-range-ending-until": "To: {endDate}",
    "reset-label": "Reset"
  },
  "activity-difficulty": {
    "beginner": "Beginner",
    "intermediate": "Intermediate",
    "professional": "Advanced",
    "all-levels": "All Levels",
    "not-specified": "Not specified",
    "beginner-description": "Suitable for participants with little to no prior experience.",
    "intermediate-description": "Best for participants with a moderate level of experience and skill in the sport.",
    "professional-description": "Recommended for participants with a high level expertise and knowledge in the sport.",
    "all-levels-description": "Suitable for beginners, intermediate, and advanced participants."
  },
  "videos-widget": {
    "level-label": "{level, select, \n BEGINNER {Beginner} \n INTERMEDIATE {Intermediate} \n PROFESSIONAL {Advanced} \n ALL {All Levels} \n other {Not specified}}",
    "language-label": "{language, select, \n DUTCH {Dutch} \n ENGLISH {English} \n FRENCH {French} \n GERMAN {German} \n ITALIAN {Italian} \n SPANISH {Spanish} \n other {Not specified}}",
    "duration-label": "{duration, select, \n UP_TO_15 {up to 15 min} \n BETWEEN_15_AND_30 {15 to 30 min} \n BETWEEN_30_AND_60 {30 to 60 min} \n BETWEEN_60_AND_90 {60 to 90 min} \n OVER_90 {more than 90 min} \n other {Not specified}}",
    "load-more": "Load more",
    "error-fetching-data": "An error occurred when fetching the videos.",
    "no-results-header": "No results found",
    "no-results-message": "We could not find any videos, try adjusting the filters.",
    "go-to-my-videos": "Go to my videos",
    "see-my-videos": "Want to see what you've already unlocked?"
  },
  "date-navigation": {
    "previous-day": "Previous day",
    "next-day": "Next day",
    "previous-week": "Previous week",
    "next-week": "Next week"
  },
  "filters": {
    "all-selected": "All",
    "teacher": "Teacher",
    "activity-type": "Activity type",
    "sport": "Sport",
    "no-results-found": "No results found",
    "clear-all": "Clear all",
    "venue": "Venues",
    "level": "Level",
    "language": "Language",
    "duration": "Duration"
  },
  "expandable-content": {
    "see-more-content": "Show more",
    "see-less-content": "Show less"
  },
  "time-of-day": {
    "morning": "Morning",
    "afternoon": "Afternoon",
    "evening": "Evening"
  },
  "sharing-actions": {
    "title": "Share it",
    "copy-text": "Copy text",
    "copy-link": "Copy link",
    "email": "Email",
    "message": "Message",
    "whatsapp": "WhatsApp",
    "tooltip-copied-text": "Text copied ✅",
    "tooltip-copied-link": "Link copied ✅"
  },
  "product-details": {
    "trial-card-badge-text": "Trial",
    "number-of-included-units-label": "Number of included units",
    "valid-from-label": "Valid from",
    "valid-for-label": "Valid for",
    "duration-of-validity-label": "Duration of validity",
    "product-validity-start": "{validityStartType, select, \n VALIDITY_START_TYPE_PURCHASE_DATE {date of purchase} \n VALIDITY_START_TYPE_FIRST_BOOKING {first booking} \n other {from {validityStart, date, short}}}",
    "product-validity-start-date": "{validityStartType, select, \n VALIDITY_START_TYPE_PURCHASE_DATE {date of purchase} \n VALIDITY_START_TYPE_FIRST_BOOKING {first booking} \n other {{validityStart}}}",
    "units": "{limit} {unit, select, \n USAGE_LIMIT_UNIT_HOURS {{limit, select, \n 1 {hour} \n other {hours}}} \n USAGE_LIMIT_UNIT_UNITS {{limit, select, \n 1 {unit} \n other {units}}} \n other {{currency}}}",
    "unlimited-label": "Unlimited",
    "membership-badge-text": "Membership",
    "runtime-label": "Runtime",
    "minimum-runtime-label": "Minimum runtime",
    "participations-label": "Participations",
    "membership-usages": "{usageLimitUnit, select, \n USAGE_LIMIT_UNIT_HOURS {{usageLimit, select, \n 1 {1 hour} \n other {{usageLimit} hours}}} \n USAGE_LIMIT_UNIT_UNITS {{usageLimit, select, \n 1 {1 participation} \n other {{usageLimit} participations}}} \n other {{usageLimit}}} / {interval}",
    "unlimited-participations-label": "Unlimited participations",
    "period-interval": "{intervalValue, select, \n 1 {} \n other {{intervalValue}}} {intervalType, select, \n INTERVAL_UNIT_DAYS {{intervalValue, plural, =1 {day}\n other {days}}} \n INTERVAL_UNIT_HOURS {{intervalValue, plural, =1 {hour}\n other {hours}}} \n INTERVAL_UNIT_MONTHS {{intervalValue, plural, =1 {month}\n other {months}}} \n INTERVAL_UNIT_WEEKS {{intervalValue, plural, =1 {week}\n other {weeks}}} \n INTERVAL_UNIT_YEARS {{intervalValue, plural, =1 {year}\n other {years}}} \n other {period}}",
    "time-period": "{intervalValue} {intervalType, select, \n INTERVAL_UNIT_DAYS {{intervalValue, plural, =1 {day}\n other {days}}} \n INTERVAL_UNIT_HOURS {{intervalValue, plural, =1 {hour}\n other {hours}}} \n INTERVAL_UNIT_MONTHS {{intervalValue, plural, =1 {month}\n other {months}}} \n INTERVAL_UNIT_WEEKS {{intervalValue, plural, =1 {week}\n other {weeks}}} \n INTERVAL_UNIT_YEARS {{intervalValue, plural, =1 {year}\n other {years}}} \n other {period}}",
    "subscribe-now": "Subscribe now",
    "buy-now": "Buy now"
  },
  "vouchers": {
    "voucher-appearance": "Voucher appearance",
    "select-voucher-amount": "Select a voucher amount (Incl. VAT):",
    "select-voucher-dropdown-placeholder": "Select a voucher amount",
    "expires-in-label": "Expires in",
    "voucher-validity": "{unit, select, \n DAYS {{value, plural, one {}=1 {1 day} other {{value} days}}} \n WEEKS {{value, plural, one {}=1 {1 week} other {{value} weeks}}} \n MONTHS {{value, plural, one {}=1 {1 month} other {{value} months}}} \n YEARS {{value, plural, one {}=1 {1 year} other {{value} years}}} \n other {value}}",
    "voucher-validity-unlimited": "Unlimited",
    "valid-at": "Valid at",
    "valid-at-all-studio-branches": "All studio branches",
    "personal-message-label": "Personal message on voucher",
    "personal-message-placeholder": "Example: Wishing you all the best.",
    "continue-to-checkout": "Continue to checkout",
    "or-enter-custom-amount-label": "or enter",
    "custom-amount-aria-label": "Optionally enter a custom monetary amount",
    "custom-amount-placeholder": "Desired amount"
  },
  "notification-center-tooltip-title": "New",
  "notification-center-tooltip-description": "Find all updates and notifications in one place",
  "activity-duration-in-minutes-short": "({formattedDuration})",
  "location-on-map-alt-text": "Location on map",
  "info-tool-tip-alt-text": "See more information",
  "add-to-calendar-alt-text": "Add to calendar"
}
